module.exports = __webpack_public_path__ + "img/trashIcon.0dfbfe69.svg";